import { getAlertMessageFunction, getCurrentYear, isValidDate } from '../../../common/Util';

// 특정 항목이 표시되어야 하는지 확인하는 공통 함수 (pSeq, pValue 기반)
const shouldDisplayItem = (item, list) => {
  // pSeq가 없으면 항상 표시 (루트 질문)
  if (!item.pSeq) return true;

  const parentSeqs = item.pSeq.split(',').map(s => s.trim());
  const parentValues = item.pValue.split(',').map(v => v.trim());

  // 모든 부모 조건이 충족되어야 표시
  return parentSeqs.every((pSeq, index) => {
    const parent = list.find(i => i.htmSeq === pSeq);
    if (!parent) return false;
    // 부모도 표시되어야 하고, 부모의 값이 pValue와 일치해야 함
    return shouldDisplayItem(parent, list) && parent.htmValue === parentValues[index];
  });
};

// Type1 전용 표시 조건 함수 (salary 특수 조건 포함)
const shouldDisplayItem01 = (item, list, salary) => {
  // pSeq가 없으면 항상 표시 (루트 질문)
  if (!item.pSeq) return true;

  // ⚠️ salary 특수 조건: 5천만원 초과 시 seq 13, 14, 15 숨김
  if (['13', '14', '15'].includes(item.htmSeq) && Number(salary) > 50000000) {
    return false;
  }

  const parentSeqs = item.pSeq.split(',').map(s => s.trim());
  const parentValues = item.pValue.split(',').map(v => v.trim());

  // 모든 부모 조건이 충족되어야 표시
  return parentSeqs.every((pSeq, index) => {
    const parent = list.find(i => i.htmSeq === pSeq);
    if (!parent) return false;
    return shouldDisplayItem01(parent, list, salary) && parent.htmValue === parentValues[index];
  });
};

//주택임차차입금 - pSeq, pValue 기반 동적 로직
export const calculateInitialDisplay01 = (list, salary) => {
  return list.filter(item => shouldDisplayItem01(item, list, salary)).map(item => item.htmSeq);
};

export const handleDisplayKey01 = (newList, displayKeys, salary, htmSeq, value) => {
  let alertToShow = null;

  // 선택된 항목의 htmValue 업데이트
  newList = newList.map(item => (item.htmSeq === htmSeq ? { ...item, htmValue: value } : item));

  // htmAlert이 있는 경우 처리 (특수 케이스 포함)
  const currentItem = newList.find(item => item.htmSeq === htmSeq);
  if (currentItem?.htmAlert) {
    // seq 4: "예(1)"면 alert (주택 소유한 경우 불가)
    if (htmSeq === '4' && value === '1') {
      alertToShow = currentItem.htmAlert;
    }
    // seq 8: salary > 5천만원 && "아니오(2)"면 alert
    else if (htmSeq === '8' && Number(salary) > 50000000 && value === '2') {
      alertToShow = currentItem.htmAlert;
    }
    // 나머지: "아니오(2)"면 alert
    else if (htmSeq !== '4' && htmSeq !== '8' && value === '2') {
      alertToShow = currentItem.htmAlert;
    }
  }

  // 새로운 displayKeys 계산 (pSeq, pValue 기반 + salary 조건)
  let newDisplayKeys = newList
    .filter(item => shouldDisplayItem01(item, newList, salary))
    .map(item => item.htmSeq);

  // 숨겨진 항목들의 값 초기화
  newList = newList.map(item => {
    if (!newDisplayKeys.includes(item.htmSeq)) {
      return { ...item, htmValue: null };
    }
    return item;
  });

  console.log('newDisplayKeys', newDisplayKeys);
  console.log('newList 111', newList);

  return { newList, newDisplayKeys, alertToShow };
};

//장기주택저당차입금 - pSeq, pValue 기반 동적 로직
export const calculateInitialDisplay02 = (list, salary) => {
  return list.filter(item => shouldDisplayItem(item, list)).map(item => item.htmSeq);
};

export const handleDisplayKey02 = (newList, displayKeys, salary, htmSeq, htmValue) => {
  let alertToShow = null;

  // 선택된 항목의 htmValue 업데이트
  newList = newList.map(item => (item.htmSeq === htmSeq ? { ...item, htmValue } : item));

  // htmAlert이 있는 경우 처리 (특수 케이스 포함)
  const currentItem = newList.find(item => item.htmSeq === htmSeq);
  if (currentItem?.htmAlert) {
    // seq 2, 12: "예(1)"면 alert
    if ((htmSeq === '2' || htmSeq === '12') && htmValue === '1') {
      alertToShow = currentItem.htmAlert;
    }
    // 나머지: "아니오(2)"면 alert
    else if (htmSeq !== '2' && htmSeq !== '12' && htmValue === '2') {
      alertToShow = currentItem.htmAlert;
    }
  }

  // 새로운 displayKeys 계산 (pSeq, pValue 기반)
  let newDisplayKeys = newList
    .filter(item => shouldDisplayItem(item, newList))
    .map(item => item.htmSeq);

  // 숨겨진 항목들의 값 초기화 (seq 15는 htmValue2도 초기화)
  newList = newList.map(item => {
    if (!newDisplayKeys.includes(item.htmSeq)) {
      if (item.htmSeq === '15') {
        return { ...item, htmValue: null, htmValue2: null };
      }
      return { ...item, htmValue: null };
    }
    return item;
  });

  console.log('alertToShow >>', alertToShow);
  return {
    newList,
    newDisplayKeys,
    alertToShow,
  };
};

//주택마련저축 - pSeq, pValue 기반 동적 로직
export const calculateInitialDisplay03 = (list, salary) => {
  return list.filter(item => shouldDisplayItem(item, list)).map(item => item.htmSeq);
};

export const handleDisplayKey03 = (newList, displayKeys, salary, htmSeq, htmValue) => {
  let alertToShow = null;

  // 선택된 항목의 htmValue 업데이트
  newList = newList.map(item => (item.htmSeq === htmSeq ? { ...item, htmValue } : item));

  // htmAlert이 있는 경우 처리
  const currentItem = newList.find(item => item.htmSeq === htmSeq);
  if (currentItem?.htmAlert && htmValue === '2') {
    alertToShow = currentItem.htmAlert;
  }

  // 새로운 displayKeys 계산 (pSeq, pValue 기반)
  let newDisplayKeys = newList
    .filter(item => shouldDisplayItem(item, newList))
    .map(item => item.htmSeq);

  // 숨겨진 항목들의 값 초기화
  newList = newList.map(item => {
    if (!newDisplayKeys.includes(item.htmSeq)) {
      return { ...item, htmValue: null };
    }
    return item;
  });

  console.log('alertToShow >>', alertToShow);
  return {
    newList,
    newDisplayKeys,
    alertToShow,
  };
};

//월세액 - pSeq, pValue 기반 동적 로직
export const calculateInitialDisplay04 = (list, salary) => {
  return list.filter(item => shouldDisplayItem(item, list)).map(item => item.htmSeq);
};

export const handleDisplayKey04 = (newList, displayKeys, salary, htmSeq, htmValue) => {
  let alertToShow = null;

  // 선택된 항목의 htmValue 업데이트
  newList = newList.map(item => (item.htmSeq === htmSeq ? { ...item, htmValue } : item));

  // htmAlert이 있는 경우 처리 (특수 케이스 포함)
  const currentItem = newList.find(item => item.htmSeq === htmSeq);
  if (currentItem?.htmAlert) {
    // seq 5: "예(1)"면 alert
    if (htmSeq === '5' && htmValue === '1') {
      alertToShow = currentItem.htmAlert;
    }
    // 나머지: "아니오(2)"면 alert
    else if (htmSeq !== '5' && htmValue === '2') {
      alertToShow = currentItem.htmAlert;
    }
  }

  // 새로운 displayKeys 계산 (pSeq, pValue 기반)
  let newDisplayKeys = newList
    .filter(item => shouldDisplayItem(item, newList))
    .map(item => item.htmSeq);

  // 숨겨진 항목들의 값 초기화
  newList = newList.map(item => {
    if (!newDisplayKeys.includes(item.htmSeq)) {
      return { ...item, htmValue: null };
    }
    return item;
  });

  console.log('alertToShow >>', alertToShow);
  return {
    newList,
    newDisplayKeys,
    alertToShow, // 알림 메시지 반환
  };
};

//주택임차차입금
export const isValidate = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  const hasError = dataList.some(data => {
    const { htmKFlag, htm001, htm002, htm003, htm004 } = data;

    if (htmKFlag === '') {
      alertMessage(t('detail.alertMessage2'));
      return true;
    }

    if (htm001 === '') {
      alertMessage(t('detail.alertMessage3'));
      return true;
    }

    if (htm002 === '') {
      alertMessage(t('detail.alertMessage4'));
      return true;
    }

    if (htm003 === '') {
      alertMessage(t('detail.alertMessage5'));
      return true;
    }

    if (htm004 === '') {
      alertMessage(t('detail.alertMessage6'));
      return true;
    }

    if (htm001 === '4' && htmKFlag === '1') {
      alertMessage(t('detail.alertMessage7'));
      return true;
    }

    return false;
  });

  return !hasError;
};

//월세액
export const isValidate04 = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  const hasError = dataList.some(data => {
    // htmFlag: 'M',
    // htmKFlag: '2',
    // htmSeq: '',
    // htm013: '', //근무기간 1
    // htm014: '', //근무기간 2
    // htm001: '', //월세액
    // htm011: '', //임차기간
    // htm012: '', //임차기간 2
    // htm016: '', //임대인성명
    // htm017: '', //임대인 주민(사업자)
    // htm004: '', //주택유형
    // htm005: '', //면적
    // htm018: '', //임대차계약서주소지

    const {
      htmKFlag,
      htm013,
      htm014,
      htm001,
      htm011,
      htm012,
      htm016,
      htm017,
      htm004,
      htm005,
      htm018,
    } = data;
    const currentYear = getCurrentYear();

    if (htmKFlag === '') {
      alertMessage(t('detail.alertMessage2'));
      return true;
    }

    if (Number(htm001) <= 0) {
      //월세액 총액 입력해라
      alertMessage(t('detail.alertMessage8'));
      return true;
    }

    //주택임차 시작일 입력~
    if (htm011 === '') {
      alertMessage(t('detail.alertMessage9'));
      return true;
    }

    //주택임차 시작일은 2024 1월1일이후
    // if (htm011.substring(0, 4) < currentYear - 1) {
    //   alertMessage(t('detail.alertMessage27'));
    //   return true;
    // }

    //주택임차 마침일 입력~
    if (htm012 === '') {
      alertMessage(t('detail.alertMessage10'));
      return true;
    }

    //주택임차 마침일은 2025 1월1일이후
    if (htm012.substring(0, 4) < currentYear) {
      alertMessage(t('detail.alertMessage11'));
      return true;
    }

    //주택임차 마침일이 시작일보다 커야함
    if (Number(htm012.replaceAll('-', '')) < Number(htm011.replaceAll('-', ''))) {
      alertMessage(t('detail.alertMessage12'));
      return true;
    }

    //근무시간 시작일 입력~
    if (htm013 === '') {
      alertMessage(t('detail.alertMessage13'));
      return true;
    }

    //근무시간 마침일 입력~
    if (htm014 === '') {
      alertMessage(t('detail.alertMessage14'));
      return true;
    }

    //근무기간을 2025년으로
    if (htm013.substring(0, 4) != currentYear || htm014.substring(0, 4) != currentYear) {
      alertMessage(t('detail.alertMessage15'));
      return true;
    }

    //근무시작일일이 마침일보다 커야함
    if (Number(htm013.replaceAll('-', '')) > Number(htm014.replaceAll('-', ''))) {
      alertMessage(t('detail.alertMessage16'));
      return true;
    }

    //임대인 성명 입력~
    if (htm016 === '') {
      alertMessage(t('detail.alertMessage17'));
      return true;
    }

    //임대인 주민번호 입력~
    if (htm017 === '') {
      alertMessage(t('detail.alertMessage18'));
      return true;
    }

    //주택유형입력~
    if (htm004 === '') {
      alertMessage(t('detail.alertMessage19'));
      return true;
    }

    //면적 입력을 너무크게 함
    if (Number(htm005) > 1000) {
      alertMessage(t('detail.alertMessage20'));
      return true;
    }

    //면적유형 을 입력해라
    if (htm005 === '') {
      if (htm004 != '7') {
        alertMessage(t('detail.alertMessage21'));
        return true;
      }

      //7일 때 htm005를 0으로 만드는 로직이 있어 확인해봐!!
    }

    //주소지 입력해라~
    if (htm018 === '') {
      alertMessage(t('detail.alertMessage22'));
      return true;
    }

    //주택임차개시일을 잘못입력
    if (!isValidDate(htm011)) {
      console.log('htm011', htm011);
      alertMessage(t('detail.alertMessage23'));
      return true;
    }

    //주택임차마침을 잘못입력
    if (!isValidDate(htm012)) {
      alertMessage(t('detail.alertMessage24'));
      return true;
    }

    //근무시작일 을 잘못입력
    if (!isValidDate(htm013)) {
      alertMessage(t('detail.alertMessage25'));
      return true;
    }

    //근무마침일을 잘못입력
    if (!isValidDate(htm014)) {
      alertMessage(t('detail.alertMessage26'));
      return true;
    }
    return false;
  });

  return !hasError;
};
